import axios from "../../utils/Axios";

export const addNewJob = async (newJob) => {
    const response = await axios.post('/jobs', newJob);
    return response.data;
}
